import { useState } from "react";
import { useTranslation } from "react-i18next";

import { CONTACT_ADDRESS, EMAIL_ADDRESS } from "../../../constants/const";

import styles from "./styles.module.scss";

type Props = {
  /** h1 on the dedicated FAQ page, h2 where the FAQ is a homepage section. */
  headingLevel?: 1 | 2;
};

// Keep the questions in sync with src/seo/faqSchema.ts (FAQPage JSON-LD).
const Faq = ({ headingLevel = 2 }: Props) => {
  const { t } = useTranslation();
  const Heading = headingLevel === 1 ? "h1" : "h2";
  const [openedQuestionsId, setOpenedQuestionsId] = useState<number[]>([]);

  const faqList = [
    {
      id: 0,
      label: t("faq.faquestion1"),
      content: (
        <div>
          <h4>{t("faq.faqAnswer1.txt1")}</h4>
          <div>
            <ul>
              <li>*{t("faq.faqAnswer1.txt2")}</li>
              <li>*{t("faq.faqAnswer1.txt3")}</li>
              <li>*{t("faq.faqAnswer1.txt4")}</li>
              <li>*{t("faq.faqAnswer1.txt5")}</li>
              <li>*{t("faq.faqAnswer1.txt6")}</li>
              <li>*{t("faq.faqAnswer1.txt7")}</li>
              <li>*{t("faq.faqAnswer1.txt8")}</li>
              <li>*{t("faq.faqAnswer1.txt9")}</li>
            </ul>
          </div>
        </div>
      ),
    },
    {
      id: 1,
      label: t("faq.faquestion2"),
      content: <div>{t("faq.faqAnswer2.txt1")}</div>,
    },
    {
      id: 3,
      label: t("faq.faquestion4"),
      content: (
        <div>
          <p>{t("faq.faqAnswer4.txt1")}</p>
        </div>
      ),
    },
    {
      id: 4,
      label: t("faq.faquestion5"),
      content: (
        <div>
          <p>{t("faq.faqAnswer5.txt1")}</p>
          <p>{t("faq.faqAnswer5.txt2")}</p>
          <p>{t("faq.faqAnswer5.txt3")}</p>
        </div>
      ),
    },
    {
      id: 5,
      label: t("faq.faquestion6"),
      content: (
        <div>
          <p className="mb-20">{t("faq.faqAnswer6.txt1")}</p>
          <p>{t("faq.faqAnswer6.txt2")}</p>
        </div>
      ),
    },
    {
      id: 6,
      label: t("faq.faquestion7"),
      content: (
        <div>
          <p className="mb-20">{t("faq.faqAnswer7.txt1")}</p>
          <p className="mb-20">{t("faq.faqAnswer7.txt2")}</p>
          <p>**{t("faq.faqAnswer7.txt3")}**</p>
        </div>
      ),
    },
    {
      id: 7,
      label: t("faq.faquestion8"),
      content: <div>{t("faq.faqAnswer8.txt1")}</div>,
    },
    {
      id: 8,
      label: t("faq.faquestion9"),
      content: (
        <div>
          <p className="mb-20">{t("faq.faqAnswer9.txt1")}</p>
          <p>{t("faq.faqAnswer9.txt2")}</p>
        </div>
      ),
    },
    {
      id: 9,
      label: t("faq.faquestion10"),
      content: (
        <div>
          <p className="mb-20">{t("faq.faqAnswer10.txt1")}</p>
          <p className="mb-20">
            {t("faq.faqAnswer10.txt2")} (<strong>{CONTACT_ADDRESS}</strong>){" "}
            {t("faq.faqAnswer10.txt3")} (<strong>{EMAIL_ADDRESS}</strong>
            ).
          </p>
          <p>{t("faq.faqAnswer10.txt5")}</p>
        </div>
      ),
    },
  ];

  function handleClickItem(id: number) {
    setOpenedQuestionsId((prev) => {
      if (prev.includes(id)) {
        return prev.filter((i) => i !== id);
      } else {
        return [...prev, id];
      }
    });
  }

  return (
    <div className={styles.faq}>
      <Heading>{t("faq.frequentlyAskedQuestions")}</Heading>
      <div className={styles.content}>
        {faqList.map((listItem) => (
          <div key={listItem.id} className={styles.listItem}>
            <div
              className={styles.label}
              onClick={() => handleClickItem(listItem.id)}
            >
              <span className={styles.sign}>
                {openedQuestionsId.includes(listItem.id) ? "-" : "+"}
              </span>
              {listItem.label}
            </div>

            <div
              className={`${styles.info} ${
                openedQuestionsId.includes(listItem.id) && styles.toggle
              }`}
            >
              {listItem.content}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
